import { Search } from '@mui/icons-material'
import { alpha, Box, InputBase, Typography, useTheme } from '@mui/material'
import { FC, useRef } from 'react'
import useIsMobile from 'shared/hooks/useIsMobile'
import { getPxAsRem } from 'shared/utils'
import { GlobalSearchModal } from './GlobalSearchModal'
import { useKeyboardShortcut } from './hooks/useKeyboardShortcut'

export const GlobalSearch: FC = () => {
    const theme = useTheme()
    const isMobile = useIsMobile()
    const triggerRef = useRef<HTMLDivElement>(null)
    const { isOpen, open, close } = useKeyboardShortcut()

    if (isMobile) return null

    return (
        <>
            <Box
                ref={triggerRef}
                onClick={open}
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: getPxAsRem(8),
                    padding: getPxAsRem(6, 12),
                    borderRadius: getPxAsRem(8),
                    border: `1px solid ${alpha(theme.palette.common.white, 0.2)}`,
                    cursor: 'pointer',
                    minWidth: getPxAsRem(220),
                    transition: 'border-color 150ms, background-color 150ms',
                    '&:hover': {
                        borderColor: alpha(theme.palette.common.white, 0.4),
                        backgroundColor: alpha(
                            theme.palette.common.white,
                            0.05
                        ),
                    },
                }}
            >
                <Search
                    sx={{
                        color: alpha(theme.palette.common.white, 0.7),
                        fontSize: getPxAsRem(20),
                    }}
                />
                <InputBase
                    placeholder="Search..."
                    readOnly
                    sx={{
                        flex: 1,
                        color: alpha(theme.palette.common.white, 0.7),
                        backgroundColor: 'transparent',
                        cursor: 'pointer',
                        '& input': {
                            cursor: 'pointer',
                            padding: 0,
                            backgroundColor: 'transparent',
                            '&::placeholder': {
                                color: alpha(theme.palette.common.white, 0.7),
                                opacity: 1,
                            },
                        },
                    }}
                />
                <Typography
                    variant="caption"
                    sx={{
                        color: alpha(theme.palette.common.white, 0.5),
                        backgroundColor: alpha(theme.palette.common.white, 0.1),
                        padding: getPxAsRem(2, 6),
                        borderRadius: getPxAsRem(4),
                        fontFamily: 'monospace',
                        fontSize: getPxAsRem(11),
                    }}
                >
                    {navigator.platform.includes('Mac') ? '⌘K' : 'Ctrl+K'}
                </Typography>
            </Box>

            <GlobalSearchModal
                isOpen={isOpen}
                onClose={close}
                anchorEl={triggerRef.current}
            />
        </>
    )
}
